import { AccredibleSelectInputComponentModule } from '@accredible-frontend-v2/forms/select-input';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TranslocoModule } from '@jsverse/transloco';
import { ProfileListSearchComponent } from '../profile-list-search/profile-list-search.component';
import { ProfileListSearchSortComponent } from './profile-list-search-sort.component';

const MATERIAL_MODULES = [MatButtonModule];

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    ProfileListSearchComponent,
    AccredibleIconComponentModule,
    AccredibleSelectInputComponentModule,
    ...MATERIAL_MODULES,
  ],
  declarations: [ProfileListSearchSortComponent],
  exports: [ProfileListSearchSortComponent],
})
export class ProfileListSearchSortModule {}
